import axios from 'axios';

const apiBaseURL = process.env.REACT_APP_API_BASE_URL || (process.env.NODE_ENV === 'development' ? 'http://localhost:5000' : '');

const api = axios.create({
  baseURL: apiBaseURL,
  withCredentials: true
});

let handle401Callback = null;

export const set401Handler = (callback) => {
  handle401Callback = callback;
};

api.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401 && handle401Callback) {
      handle401Callback();
    }
    return Promise.reject(error);
  }
);

export default api;
